import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
export var getEntity = function getEntity(type, id) {
  return finectAPI({
    version: 'v4',
    path: ['product'].includes(type) ? "products/".concat(id) : "contents/".concat(type, "s/").concat(id),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data;
    }
  });
};